export const BASE_URL =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_DEV_MODE
    : process.env.REACT_APP_PRO_MODE;
export const AUTH_URL = BASE_URL + "/auth";
export const LOGIN_URL = AUTH_URL + "/login";
export const FORGOT_PASSWORD_URL = AUTH_URL + "/forgot-password";
export const RESET_PASSWORD_URL = AUTH_URL + "/reset-password";
export const USER_URL = BASE_URL + "/admin/users";
export const ROLES_URL = BASE_URL + "/admin/roles";
export const INSTITUTIONS_URL = BASE_URL + "/admin/institutions";
export const COUNTRIES_URL = BASE_URL + "/admin/countries";
export const BEACONS_URL = BASE_URL + "/admin/beacons";
export const INCIDENTS_URL = BASE_URL + "/admin/incidents";
export const INCIDENT_TYPES_URL = BASE_URL + "/admin/incidents/types";
export const INCIDENT_STATUS_TYPES_URL =
  BASE_URL + "/admin/incidents/status-types";
export const INCIDENT_ACTIVITIES_URL = BASE_URL + "/admin/incident-activities";
export const GROUPS_URL = BASE_URL + "/admin/groups";
export const PROTOCOLS_URL = BASE_URL + "/admin/protocols";
export const EXTERNAL_INCIDENTS_URL = BASE_URL + "/external-web/incidents";
export const EXTERNAL_INCIDENT_ACTIVITIES_URL =
  BASE_URL + "/external-web/incident-activities";
export const SETTINGS_URL = BASE_URL + "/admin/settings";
export const STATISTICS_URL = BASE_URL + "/admin/statistics";
export const ADMIN_USERS_URL = BASE_URL + "/admin/users";

// Web Operator endpoints
export const WEB_USERS_URL = BASE_URL + "/web/users";
export const WEB_INCIDENTS_URL = BASE_URL + "/web/incidents";
export const WEB_INCIDENT_TYPES_URL = BASE_URL + "/web/incidents/types";
export const WEB_INCIDENT_STATUS_TYPES_URL =
  BASE_URL + "/web/incidents/status-types";
export const WEB_INCIDENT_ACTIVITIES_URL =
  BASE_URL + "/web/incident-activities";
export const WEB_PROTOCOLS_URL = BASE_URL + "/web/protocols";
export const WEB_STATISTICS_URL = BASE_URL + "/web/statistics";

